export default {
  dropzoneOptions: {
    acceptedFiles: ".xls,.xlsx,.csv,.tsv",
    url: "",
    parallelUploads: 5,
    timeout: 0, // sem prazo: o padrão do Dropzone (30 s) cancelava arquivo grande em rede lenta
    maxFilesize: 1073741824, //MB
    maxColumns: 70,
    maxRows: 500000,
    filesizeBase: 1000, //MB
    maxFiles: 10,
    addRemoveLinks: true,
    headers: {
      Authorization: ""
    },
    dictDefaultMessage: `Arraste um arquivo para cá.`,
    dictFallbackMessage: "Seu navegador não possui suporte a drag'n'drop",
    dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Máximo permitido: {{maxFilesize}}MiB.",
    dictInvalidFileType: "Você não pode subir arquivos deste tipo.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancelar",
    dictUploadCanceled: "Cancelado",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remover",
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: "Você não pode subir mais arquivos.",
    dictFileSizeUnits: {
      tb: "TB",
      gb: "GB",
      mb: "MB",
      kb: "KB",
      b: "b"
    },
    previewTemplate: `
<div class="dz-preview dz-file-preview">
  <div class="dz-details">
    <div class="dz-thumbnail">
      <img data-dz-thumbnail>
      <span class="dz-nopreview">Sem preview</span>
      <div class="dz-success-mark"></div>
      <div class="dz-error-mark"></div>
      <div class="dz-error-message"><span data-dz-errormessage></span></div>
      <div class="progress"><div class="progress-bar progress-bar-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div></div>
    </div>
    <div class="dz-filename" data-dz-name></div>
    <div class="dz-size" data-dz-size></div>
  </div>
</div>`,
    thumbnailWidth: 80
  },
  formatBytes(bytes, decimals = 2) {
    /*
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    */
    if (!Number(bytes)) {
      return '0 Bytes';
    }

    const kbToBytes = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
      'Bytes',
      'KiB',
      'MiB',
      'GiB',
      'TiB',
      'PiB',
      'EiB',
      'ZiB',
      'YiB',
    ];

    const index = Math.floor(
      Math.log(bytes) / Math.log(kbToBytes),
    );

    return `${parseFloat(
      (bytes / Math.pow(kbToBytes, index)).toFixed(dm),
    )} ${sizes[index]}`
  }
}
